import { apiCall } from './api';
import { apiPost, apiPut } from '../utils/axios';

const base_url = `/auth`;

export const signIn = (data) => {
  return apiPost(`${base_url}/login`, data);
};

export const signUp = (data) => {
  return apiPost(`${base_url}/register`, data);
};

export const verifyEmail = (data) => {
  return apiPut(`${base_url}/verify-email`, data);
};

export const resendVerifyCode = () => {
  return apiPost(`${base_url}/resend-code`);
};

export const sendResetPasswordEmail = (data) => {
  return apiPost(`${base_url}/send-reset-email`, data);
};

export const resetPassword = (data) => {
  console.log('callingapi', data);
  return apiPost(`${base_url}/reset-password`, data);
};

export const stripeOAuth = (code, token) => {
  return apiCall({
    method: 'post',
    url: '/stripe/connect/oauth',
    headers: {
      Authorization: `Bearer ${token}`,
    },
    data: { code },
  });
};

export const checkIfAdmin = (token) => {
  return apiPost(`${base_url}/is-admin`, { token });
};

export const impersonate = (data) => {
  return apiPost(`${base_url}/impersonate`, data);
};
